import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ImportJob {
  id: string;
  org_name: string | null;
  provider_type: string;
  status: string;
  total_plants: number;
  processed_plants: number;
  created_at: string;
  completed_at: string | null;
}

export interface FailedImportQueueItem {
  id: string;
  import_job_id: string;
  provider_plant_id: string | null;
  status: string;
  error: string | null;
  created_at: string;
  updated_at: string;
}

export interface ProviderSessionHealth {
  provider_type: string;
  total_sessions: number;
  active_sessions: number;
  expired_sessions: number;
}

export interface ProvisionalProperty {
  id: string;
  name: string;
  address: string | null;
  org_name: string | null;
  created_at: string;
}

export interface OnboardingIncompleteProperty {
  id: string;
  name: string;
  address: string | null;
  org_name: string | null;
  readiness_state: string | null;
  data_source_mode: string | null;
  created_at: string;
}

export interface OnboardingDiagnosticsData {
  recent_import_jobs: ImportJob[];
  failed_import_queue: FailedImportQueueItem[];
  provider_session_health: ProviderSessionHealth[];
  provisional_properties: ProvisionalProperty[];
  onboarding_incomplete: OnboardingIncompleteProperty[];
}

async function fetchOnboardingDiagnostics(): Promise<OnboardingDiagnosticsData> {
  const { data, error } = await supabase.rpc('admin_onboarding_diagnostics');
  if (error) throw error;
  return data as OnboardingDiagnosticsData;
}

export function useAdminOnboardingDiagnostics() {
  return useQuery({
    queryKey: ['admin-onboarding-diagnostics'],
    queryFn: fetchOnboardingDiagnostics,
  });
}
